import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../../../utils/http";
import {
  CreateCustomerPayload,
  CreateCustomerProfilePayload,
  UpdateCustomerDetailsPayload,
} from "./types";
import { TableFilterParams } from "../util/types";

const BaseURL = process.env.REACT_APP_API_URL;

export const createCustomerAction = createAsyncThunk(
  "customers/create_customer",
  async (body: CreateCustomerPayload, { rejectWithValue }) => {
    try {
      const resp = await http.post({
        url: `${BaseURL}/organisation-portal/create-new-organisation-account-and-user`,
        body,
      });

      return resp;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchAllCustomers = createAsyncThunk(
  "fetch_all_customers",
  async (organisationId: string, { rejectWithValue }) => {
    try {
      const resp = await http.get({
        url: `${BaseURL}/organisation-portal/find-all-organisation-accounts/${organisationId}`,
      });

      return resp;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchFilteredCustomersAction = createAsyncThunk(
  "fetch_filtered_customers",
  async (filterParams: TableFilterParams, { rejectWithValue }) => {
    try {
      const { organisationId, page, rows, filters } = filterParams;
      const resp = await http.get({
        url: `${BaseURL}/organisation-portal/find-filtered-organisation-accounts/${organisationId}`,
        query: {
          page,
          rows,
          searchString: filters?.global?.value,
        },
      });

      return resp;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchCustomerDetailsAction = createAsyncThunk(
  "find_customer_details",
  async (
    params: { organisationId: string; customerId: string },
    { rejectWithValue }
  ) => {
    try {
      const resp = await http.get({
        url: `${BaseURL}/organisation-portal/find-account-by-id/${params.organisationId}/${params.customerId}`,
      });
      return resp;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateCustomerDetailsAction = createAsyncThunk(
  "update_customer_details",
  async (payload: UpdateCustomerDetailsPayload, { rejectWithValue }) => {
    try {
      const resp = await http.patch({
        url: `${BaseURL}/organisation-portal/update-organisation-customer`,
        body: payload,
      });

      return resp;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchCustomerBookingsAction = createAsyncThunk(
  "find_customer_bookings",
  async (
    params: { organisationId: string; userId: string },
    { rejectWithValue }
  ) => {
    try {
      const resp = await http.get({
        url: `${BaseURL}/organisation-portal/find-customer-bookings/${params.organisationId}/${params.userId}`,
      });
      return resp;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const createCustomerProfileAction = createAsyncThunk(
  "customers/create_customer_profile",
  async (body: CreateCustomerProfilePayload, { rejectWithValue }) => {
    try {
      const resp = await http.post({
        url: `${BaseURL}/organisation-portal/create-new-organisation-user-in-old-account`,
        body,
      });

      return resp;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchFilteredProfilesAction = createAsyncThunk(
  "fetch_filtered_profiles",
  async (filterParams: TableFilterParams, { rejectWithValue }) => {
    try {
      const { organisationId, customerId, page, rows, filters } = filterParams;
      const resp = await http.get({
        url: `${BaseURL}/organisation-portal/find-filtered-organisation-customer-profiles/${organisationId}/${customerId}`,
        query: {
          page,
          rows,
          searchString: filters?.global?.value,
        },
      });

      return resp;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
